export function getVsz(vszId, query = '') {
  return {
    path: `vszs/${vszId}${query}`,
    method: 'GET',
  };
}

export function searchVszs(search, contentType) {
  return {
    accept: contentType,
    path: 'vszs',
  };
}

export function getVszZones(vszId) {
  return {
    path: `vszs/${vszId}/zones`,
    method: 'GET',
  };
}

export function checkVsz(vszId) {
  return {
    path: `vszs/${vszId}/check`,
    method: 'GET',
  };
}

export function checkVszZone(vszId, zoneId) {
  return {
    path: `vszs/${vszId}/zones/${zoneId}`,
    method: 'GET',
  };
}

export function getSmartzoneWlans(vszId, zoneId) {
  return {
    path: `vszs/${vszId}/zones/${zoneId}/wlans`,
    method: 'GET',
  };
}

export function checkWlan(vszId, zoneId, wlanId) {
  return {
    path: `vszs/${vszId}/zones/${zoneId}/wlans/${wlanId}`,
    method: 'GET',
  };
}
